import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-1" }
const _hoisted_2 = { class: "text-body-2" }
const _hoisted_3 = { class: "text-body-2" }
const _hoisted_4 = { class: "text-body-2" }
const _hoisted_5 = { class: "text-body-2" }
const _hoisted_6 = { class: "text-body-2" }
const _hoisted_7 = { class: "text-body-2" }
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = { class: "text-body-2" }
const _hoisted_10 = { class: "text-subtitle-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    density: "compact",
    class: "ma-0 pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "mx-0 my-2 pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_1, [
                _cache[32] || (_cache[32] = _createTextVNode("Advanced Parameters ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Choose the parameters below you want to include in requests to the model."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [31]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (!_ctx.hideSamplingParams)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6",
                density: "compact",
                class: "ma-0 pa-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_2, [
                    _cache[34] || (_cache[34] = _createTextVNode("Temperature ")),
                    (_ctx.showGlobalTooltips)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          position: "top",
                          "max-width": "300",
                          text: "The temperature is randomness of response. Higher number is more random. If setting temperature, don't set Top P"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createTextVNode("mdi-information-outline")
                              ])),
                              _: 2,
                              __: [33]
                            }, 1040)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "6",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_3, [
                _cache[36] || (_cache[36] = _createTextVNode("Max Tokens ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Maximum number of tokens that the agent can respond with. -1 means no limit."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [35]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (!_ctx.hideSamplingParams)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6",
                density: "compact",
                class: "ma-0 pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_slider, {
                    modelValue: _ctx.temperature,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.temperature) = $event)),
                      _ctx.onChange
                    ],
                    min: 0.01,
                    max: 1,
                    step: 0.01,
                    color: "secondary",
                    class: "pt-2 pl-1",
                    disabled: !_ctx.includeTemperature
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.temperature,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.temperature) = $event)),
                        onChange: _ctx.onChange,
                        density: "compact",
                        style: {"width":"80px"},
                        type: "number",
                        variant: "outlined",
                        "hide-details": "",
                        class: "smaller-text number",
                        min: 0.01,
                        max: 1,
                        step: 0.01
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "6",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.maxTokens,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maxTokens) = $event)),
                density: "compact",
                type: "number",
                variant: "outlined",
                "hide-details": "",
                class: "mt-2 smaller-text number",
                rules: [(v) => v >= -1],
                min: -1,
                step: 10,
                onChange: _cache[3] || (_cache[3] = ($event: any) => {_ctx.getNumber(_ctx.maxTokens) < -1 ? (_ctx.maxTokens = -1) : null; _ctx.onChange()}),
                disabled: !_ctx.includeMaxTokens
              }, null, 8, ["modelValue", "rules", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (!_ctx.hideSamplingParams)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6",
                density: "compact",
                class: "ma-0 pa-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_4, [
                    _cache[38] || (_cache[38] = _createTextVNode("Top P ")),
                    (_ctx.showGlobalTooltips)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          position: "top",
                          "max-width": "300",
                          text: "An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered. If setting Top P, don't set temperature."
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                              default: _withCtx(() => _cache[37] || (_cache[37] = [
                                _createTextVNode("mdi-information-outline")
                              ])),
                              _: 2,
                              __: [37]
                            }, 1040)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "6",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_5, [
                _cache[40] || (_cache[40] = _createTextVNode("Top K ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Only sample from the top K options for each subsequent token. Used to remove long tail low probability responses."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [39]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (!_ctx.hideSamplingParams)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6",
                density: "compact",
                class: "ma-0 pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_slider, {
                    modelValue: _ctx.topP,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.topP) = $event)),
                      _ctx.onChange
                    ],
                    min: 0.01,
                    max: 1,
                    step: 0.01,
                    color: "secondary",
                    class: "pt-2 pl-1",
                    disabled: !_ctx.includeTopP
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.topP,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.topP) = $event)),
                        onChange: _ctx.onChange,
                        density: "compact",
                        style: {"width":"80px"},
                        type: "number",
                        variant: "outlined",
                        "hide-details": "",
                        class: "smaller-text number",
                        min: 0.01,
                        max: 1,
                        step: 0.01
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "6",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.topK,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.topK) = $event)),
                density: "compact",
                type: "number",
                variant: "outlined",
                "hide-details": "",
                class: "mt-2 smaller-text number",
                rules: [(v) => v >= -1],
                min: 0,
                step: 10,
                onChange: _cache[7] || (_cache[7] = ($event: any) => {_ctx.getNumber(_ctx.topK) < 0 ? (_ctx.topK = 0) : null; _ctx.onChange()}),
                disabled: !_ctx.includeTopK
              }, null, 8, ["modelValue", "rules", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_6, [
                _cache[42] || (_cache[42] = _createTextVNode("Seed ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Attempt deterministic responses. Same seed & other parameters will produce same response. Doesn't always work."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [41]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "8",
            density: "compact",
            class: "ma-0 py-0 pl-2 pr-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_7, [
                _cache[44] || (_cache[44] = _createTextVNode("Stop ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Up to 4 words or strings that will cause the model to stop generating text. If multiple, use a comma to separate."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [43]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.seed,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.seed) = $event)),
                density: "compact",
                type: "number",
                variant: "outlined",
                "hide-details": "",
                class: "mt-2 smaller-text number",
                rules: [(v) => v >= 0],
                min: 0,
                step: 10,
                onChange: _cache[9] || (_cache[9] = ($event: any) => {_ctx.getNumber(_ctx.seed) < 0 ? (_ctx.seed = 0) : null; _ctx.onChange()}),
                disabled: !_ctx.includeSeed
              }, null, 8, ["modelValue", "rules", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "8",
            density: "compact",
            class: "ma-0 py-0 pl-2 pr-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.stop,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stop) = $event)),
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                class: "mt-2 smaller-text",
                disabled: !_ctx.includeStop
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isGpt5Model)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, {
              density: "compact",
              class: "ma-0 pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  density: "compact",
                  class: "ma-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", _hoisted_8, [
                      _cache[46] || (_cache[46] = _createTextVNode("Reasoning Effort ")),
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Controls how much reasoning the model performs. GPT-5 only."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [45]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  density: "compact",
                  class: "ma-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", _hoisted_9, [
                      _cache[48] || (_cache[48] = _createTextVNode("Verbosity ")),
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Constrains the verbosity of the model's response. GPT-5 only."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [47]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              density: "compact",
              class: "ma-0 pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  density: "compact",
                  class: "ma-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.reasoningEffort,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.reasoningEffort) = $event)),
                        _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChange()))
                      ],
                      items: ['none', 'minimal', 'low', 'medium', 'high', 'xhigh'],
                      density: "compact",
                      variant: "outlined",
                      "hide-details": "",
                      class: "mt-2",
                      label: "Reasoning Effort",
                      disabled: !_ctx.includeReasoningEffort
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  density: "compact",
                  class: "ma-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.verbosity,
                      "onUpdate:modelValue": [
                        _cache[13] || (_cache[13] = ($event: any) => ((_ctx.verbosity) = $event)),
                        _cache[14] || (_cache[14] = ($event: any) => (_ctx.onChange()))
                      ],
                      items: ['low', 'medium', 'high'],
                      density: "compact",
                      variant: "outlined",
                      "hide-details": "",
                      class: "mt-2",
                      label: "Verbosity",
                      disabled: !_ctx.includeVerbosity
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "mx-0 my-2 pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_10, [
                _cache[50] || (_cache[50] = _createTextVNode("Include Parameters ")),
                (_ctx.showGlobalTooltips)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      position: "top",
                      "max-width": "300",
                      text: "Toggle the switches below to include or exclude parameters in requests to the model. This will serve as\n          the default for agents that use this model, but can be overridden per agent."
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, { size: "x-small" }), {
                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 2,
                          __: [49]
                        }, 1040)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 py-0 pl-2 pr-0"
          }, {
            default: _withCtx(() => [
              (!_ctx.hideSamplingParams)
                ? (_openBlock(), _createBlock(_component_v_switch, {
                    key: 0,
                    modelValue: _ctx.includeTemperature,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.includeTemperature) = $event)),
                    label: "Temperature",
                    "hide-details": "",
                    inline: "",
                    inset: "",
                    class: "model-option-switch d-inline-block ml-0 mr-3",
                    density: "compact",
                    color: "secondary",
                    "base-color": "surface-variant",
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleChange('temperature')))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.includeMaxTokens,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.includeMaxTokens) = $event)),
                label: "Max Tokens",
                "hide-details": "",
                inline: "",
                inset: "",
                class: "model-option-switch d-inline-block ml-0 mr-3",
                density: "compact",
                color: "secondary",
                "base-color": "surface-variant",
                onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleChange('maxTokens')))
              }, null, 8, ["modelValue"]),
              (!_ctx.hideSamplingParams)
                ? (_openBlock(), _createBlock(_component_v_switch, {
                    key: 1,
                    modelValue: _ctx.includeTopP,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.includeTopP) = $event)),
                    label: "Top P",
                    "hide-details": "",
                    inline: "",
                    inset: "",
                    class: "model-option-switch d-inline-block ml-0 mr-3",
                    density: "compact",
                    color: "secondary",
                    "base-color": "surface-variant",
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleChange('topP')))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.includeTopK,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.includeTopK) = $event)),
                label: "Top K",
                "hide-details": "",
                inline: "",
                inset: "",
                class: "model-option-switch d-inline-block ml-0 mr-3",
                density: "compact",
                color: "secondary",
                "base-color": "surface-variant",
                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleChange('topK')))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.includeSeed,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.includeSeed) = $event)),
                label: "Seed",
                "hide-details": "",
                inline: "",
                inset: "",
                class: "model-option-switch d-inline-block ml-0 mr-3",
                density: "compact",
                color: "secondary",
                "base-color": "surface-variant",
                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleChange('seed')))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.includeStop,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.includeStop) = $event)),
                label: "Stop",
                "hide-details": "",
                inline: "",
                inset: "",
                class: "model-option-switch d-inline-block ml-0 mr-0",
                density: "compact",
                color: "secondary",
                "base-color": "surface-variant",
                onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.toggleChange('stop')))
              }, null, 8, ["modelValue"]),
              (_ctx.isGpt5Model)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.includeReasoningEffort,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.includeReasoningEffort) = $event)),
                      label: "Reasoning",
                      "hide-details": "",
                      inline: "",
                      inset: "",
                      class: "model-option-switch d-inline-block ml-0 mr-3",
                      density: "compact",
                      color: "secondary",
                      "base-color": "surface-variant",
                      onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleChange('reasoningEffort')))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.includeVerbosity,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.includeVerbosity) = $event)),
                      label: "Verbosity",
                      "hide-details": "",
                      inline: "",
                      inset: "",
                      class: "model-option-switch d-inline-block ml-0 mr-0",
                      density: "compact",
                      color: "secondary",
                      "base-color": "surface-variant",
                      onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.toggleChange('verbosity')))
                    }, null, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}